import React, { useState, useEffect } from 'react'
import { Container, Form, FormGroup, FormField, Input, Divider, Segment, Button, Icon } from 'semantic-ui-react'

const Links = ({ savedDict, onStateChange }) => {
    const [newMetaUpdateLinks, setNewMetaUpdateLinks] = useState(savedDict.newMetaUpdateLinks)
    const [generalGuideLinks, setGeneralGuideLinks] = useState(savedDict.generalGuideLinks)
    const [howToPlayLinks, setHowToPlayLinks] = useState(savedDict.howToPlayLinks)
    const [esportsEventLinks, setEsportsEventLinks] = useState(savedDict.esportsEventLinks)
    const [memesFunnyLinks, setMemesFunnyLinks] = useState(savedDict.memesFunnyLinks)
    const [officialWebsiteLink, setOfficialWebsiteLink] = useState(savedDict.officialWebsiteLink)
    const [fandomLink, setFandomLink] = useState(savedDict.fandomLink)
    const [redditLink, setRedditLink] = useState(savedDict.redditLink)

    const handleChangeField = e => {
        const { name, value } = e.target
        if (name === 'officialWebsiteLink') setOfficialWebsiteLink(value)
        if (name === 'fandomLink') setFandomLink(value)
        if (name === 'redditLink') setRedditLink(value)
        onStateChange({
            newMetaUpdateLinks,
            generalGuideLinks,
            howToPlayLinks,
            esportsEventLinks,
            memesFunnyLinks,
            officialWebsiteLink: name === 'officialWebsiteLink' ? value : officialWebsiteLink,
            fandomLink: name === 'fandomLink' ? value : fandomLink,
            redditLink: name === 'redditLink' ? value : redditLink,
        })
    }

    const handleChangeFieldVideoLink = (e, index, str) => {
        const { name, value } = e.target
        let updatedLinks
        switch (str) {
            case 'New Patch and Meta Updates':
                updatedLinks = [...newMetaUpdateLinks]
                updatedLinks[index] = { ...updatedLinks[index], [name === 'newMetaUpdateLinks' ? 'name' : 'link']: value }
                setNewMetaUpdateLinks(updatedLinks)
                break
            case 'General Guide, Tips and Tricks':
                updatedLinks = [...generalGuideLinks]
                updatedLinks[index] = { ...updatedLinks[index], [name === 'generalGuideLinks' ? 'name' : 'link']: value }
                setGeneralGuideLinks(updatedLinks)
                break
            case 'How to Play & Getting Started':
                updatedLinks = [...howToPlayLinks]
                updatedLinks[index] = { ...updatedLinks[index], [name === 'howToPlayLinks' ? 'name' : 'link']: value }
                setHowToPlayLinks(updatedLinks)
                break
            case 'e-Sports Events':
                updatedLinks = [...esportsEventLinks]
                updatedLinks[index] = { ...updatedLinks[index], [name === 'esportsEventLinks' ? 'name' : 'link']: value }
                setEsportsEventLinks(updatedLinks)
                break
            case 'Memes, WTF Moments, Funny':
                updatedLinks = [...memesFunnyLinks]
                updatedLinks[index] = { ...updatedLinks[index], [name === 'memesFunnyLinks' ? 'name' : 'link']: value }
                setMemesFunnyLinks(updatedLinks)
                break
            default:
                break
        }
        onStateChange({ newMetaUpdateLinks, generalGuideLinks, howToPlayLinks, esportsEventLinks, memesFunnyLinks, officialWebsiteLink, fandomLink, redditLink })
    }

    const handleAddNewVideo = str => {
        let updatedLinks
        switch (str) {
            case 'New Patch and Meta Updates':
                updatedLinks = [...newMetaUpdateLinks, { name: '', link: '' }]
                setNewMetaUpdateLinks(updatedLinks)
                break
            case 'General Guide, Tips and Tricks':
                updatedLinks = [...generalGuideLinks, { name: '', link: '' }]
                setGeneralGuideLinks(updatedLinks)
                break
            case 'How to Play & Getting Started':
                updatedLinks = [...howToPlayLinks, { name: '', link: '' }]
                setHowToPlayLinks(updatedLinks)
                break
            case 'e-Sports Events':
                updatedLinks = [...esportsEventLinks, { name: '', link: '' }]
                setEsportsEventLinks(updatedLinks)
                break
            case 'Memes, WTF Moments, Funny':
                updatedLinks = [...memesFunnyLinks, { name: '', link: '' }]
                setMemesFunnyLinks(updatedLinks)
                break
            default:
                break
        }
        onStateChange({ newMetaUpdateLinks, generalGuideLinks, howToPlayLinks, esportsEventLinks, memesFunnyLinks, officialWebsiteLink, fandomLink, redditLink })
    }

    const renderLinks = (links, str) => {
        if (!links) return null
        const rows = []
        for (const [i, link] of links.entries()) {
            if (i > 0) rows.push(<Divider inverted key={`divider-${i}`} style={{ marginTop: 25, marginBottom: 25 }}/>)
            rows.push(
                <div key={`link-${i}`}>
                    <b style={{ color: 'white' }}>Video #{i + 1}</b>
                    <FormGroup style={{ marginTop: 20 }} widths='equal'>
                        <FormField control={Input} label='Name' name={str.toLowerCase().replace(/[^a-z]/g, '') + 'Links'} value={link.name} placeholder='Name' onChange={e => handleChangeFieldVideoLink(e, i, str)} inverted className="dark-theme-input"/>
                        <FormField control={Input} label='Link' name={str.toLowerCase().replace(/[^a-z]/g, '') + 'Links'} value={link.link} placeholder='Link' onChange={e => handleChangeFieldVideoLink(e, i, str)} inverted className="dark-theme-input"/>
                    </FormGroup>
                </div>
            )
        }
        rows.push(
            <Button inverted basic key={str + '-button'} style={{ marginTop: links.length === 0 ? 0 : 8 }} color='blue' size='tiny' onClick={() => handleAddNewVideo(str)}><Icon name='add'/>Add New Video</Button>
        )
        return (
            <div style={{ marginBottom: 30 }}>
                <h4 style={{ color: 'white' }}>{str}</h4>
                <Segment inverted style={{ border: '1px solid #444', padding: 20 }}>{rows}</Segment>
            </div>
        )
    }

    return (
        <Container inverted style={{ background: '#1b1c1d', padding: '20px' }}>
            <Form inverted>
                {renderLinks(newMetaUpdateLinks, 'New Patch and Meta Updates')}
                {renderLinks(generalGuideLinks, 'General Guide, Tips and Tricks')}
                {renderLinks(howToPlayLinks, 'How to Play & Getting Started')}
                {renderLinks(esportsEventLinks, 'e-Sports Events')}
                {renderLinks(memesFunnyLinks, 'Memes, WTF Moments, Funny')}
                <Divider inverted style={{ marginTop: 30, marginBottom: 30 }}/>
                <FormField control={Input} label='Official Game Website' name='officialWebsiteLink' value={officialWebsiteLink} placeholder='Official Game Website' onChange={handleChangeField} className="dark-theme-input"/>
                <FormField control={Input} label='Fandom' name='fandomLink' value={fandomLink} placeholder='Fandom' onChange={handleChangeField} className="dark-theme-input"/>
                <FormField control={Input} label='Reddit' name='redditLink' value={redditLink} placeholder='Reddit' onChange={handleChangeField} className="dark-theme-input"/>
            </Form>
        </Container>
    )
}

export default Links